export default {"src":"/_next/static/media/bracket-arrow.1c1dc676.svg","height":101,"width":739,"blurWidth":0,"blurHeight":0};